import axios from "axios";
import Params from "@/plugin/params";

const instance = axios.create({
  baseURL: Params.api,
  timeout: 60000
});

export default instance;